import React from "react";
import "./pincard.css";

function PinCard(props) {
  return (
    <div class="card min-h-[12rem] w-full flex flex-col gap-2 items-center justify-center relative overflow-hidden group">
      <h1 class="title text-center">{props.title}</h1>
      <p class="achievement__content text-left">{props.description}</p>
      {/* button */}
      <div class="scrolldown self-end group">
        <div class="chevrons">
          <div class="chevrondown"></div>
          <div class="chevrondown"></div>
        </div>
      </div>
      <img
        className=" certi w-full h-full absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-1/2 rounded-2xl 
        group-hover:-translate-y-1/2 transition-all duration-200 bg-[rgba(248, 247, 216, 0.7)]"
        src={props.img}
        alt=""
        loading="lazy"
      />
    </div>
  );
}

export default PinCard;
